import { DataType } from "./DataType";
import { DbDisplayValue } from "../DbDisplayValue";
import { DisplayType } from "../constants/DisplayType";
import { ExtendedDataType } from "./ExtendedDataType";
import { MetadataFieldProps } from "./MetadataFieldProps";

export class MetadataField implements MetadataFieldProps {
    name: string;
    dataType: DataType;
    extDataType: ExtendedDataType;
    length: number;
    precision: number;
    scale: number;
    caption: string;
    tableName: string;
    tableAlias: string;
    required: boolean;
    requiredSearch: boolean;
    lookupModel: string;
    listLayout: string;
    upshifted: boolean;
    allowAdd: boolean;
    allowUpdate: boolean;
    allowSearch: boolean;
    private _displayType: DisplayType;
    private _dbDisplayValues: DbDisplayValue[];
    dynamicDbDisplayValues: boolean;

    constructor(props?: Partial<MetadataFieldProps>) {
        if (props != null)
            for (const key in props)
                this[key] = props[key];
    }

    fillFromApiResponse(apiResponse: any) {
        for (const key in apiResponse)
            this[key] = apiResponse[key];
    }

    getDisplayValue(dbValue: string): string {
        if (dbValue != null && this.dbDisplayValues != null)
            for (const dbDisplayValue of this._dbDisplayValues)
                if (dbDisplayValue.value === dbValue)
                    return dbDisplayValue.displayValue;
        return null;
    }

    get displayType() {
        if (this._displayType == null) {
            if (this.extDataType != null) {
                switch (this.extDataType) {
                    case "city": this._displayType = DisplayType.CITY; break;
                    case "email": this._displayType = DisplayType.EMAIL; break;
                    case "location": this._displayType = DisplayType.LOCATION; break;
                    case "phone": this._displayType = DisplayType.PHONE; break;
                    case "state": this._displayType = DisplayType.STATE; break;
                }
            }
            else {
                switch (this.dataType) {
                    // case "bool": this._displayType = DisplayType.BOOLEAN; break;
                    case DataType.CURRENCY: this._displayType = DisplayType.CURRENCY; break;
                    case DataType.DATE: this._displayType = DisplayType.DATE; break;
                    case DataType.DATERANGE: this._displayType = DisplayType.DATERANGE; break;
                    case DataType.TIME: this._displayType = DisplayType.TIME; break;
                    case DataType.DATETIME: this._displayType = DisplayType.DATETIME; break;
                    case DataType.FLOAT: this._displayType = DisplayType.DECIMAL; break;
                    case DataType.INT: this._displayType = DisplayType.INTEGER; break;
                }
            }
        }
        if (this._displayType == null)
            this._displayType = DisplayType.STRING;
        return this._displayType;
    }

    get dbDisplayValues(): DbDisplayValue[] {
        return this._dbDisplayValues;
    }

    set dbDisplayValues(values: any) {
        if (values != null)
            this._dbDisplayValues = [];
        for (const value of values) {
            const dbDisplayValue = new DbDisplayValue(value["value"], value["displayValue"]);
            this._dbDisplayValues.push(dbDisplayValue);
        }
    }
}
